import {NgModule} from "@angular/core";
import {RouterModule, Routes} from "@angular/router";
import {MapPageComponent} from "./pages/map-page/map-page.component";
import {NotFoundPageComponent} from "./pages/not-found-page/not-found-page.component";
import {AppRedirectComponent} from "./pages/app-redirect/app-redirect.component";
import {environment} from "src/environments/environment";


var routes: Routes = [];

if (environment.application == "NjdbPåWebb") {
    routes = [
        {path: "", redirectTo: "map", pathMatch: "full"},
        {
            path: "map",
            component: MapPageComponent,
            title: "NJDB på webb",
        },
        {path: "not-found", component: NotFoundPageComponent, title: "Ogiltlig url"},
        {path: "**", component: AppRedirectComponent, title: "Ogiltlig url"},
    ];
} else if (environment.application == "JNBKarta") {
    routes = [
        {path: "", redirectTo: "map", pathMatch: "full"},
        {
            path: "map",
            component: MapPageComponent,
            title: "JNB Karta",
        },
        {path: "not-found", component: NotFoundPageComponent, title: "Ogiltlig url"},
        {path: "**", component: AppRedirectComponent, title: "Ogiltlig url"},
    ];
}

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {
}
